<template>
  <div class="renetwork-container">
		<el-dialog :visible.sync="visible"
			:title="title"
			:close-on-click-modal="false"
			size="large"
			width="58%"
            ref="renetworkRef"
			:before-close="handleClose" class="bind-dialog  create-host">
            <div class="tip-warning mb20 lh20" 
				v-html="$t('privateNetInstance.renetworkTip')">
			</div>
            <el-form>
                <!--网络接口数量-->
                <el-form-item :label="$t('create.text.networkQuantity') | withColon">
                    <el-radio-button>
                        {{ this.rowInfo.interfaceMode ==='bond'?$t('create.text.singleInternetAccess'):$t('create.text.doubleInternetAccess')}}
                    </el-radio-button>
                </el-form-item>
                <!--网络接口名称-->
                <el-form-item :label="$t('create.text.networkName') | withColon" v-if="rowInfo.interfaceMode ==='bond'">
                    <el-radio-button>{{$t('create.text.singleInternetAccessChiefName')}}
                    </el-radio-button>
                </el-form-item>
                <el-form-item :label="$t('create.text.networkName') | withColon" v-else>
                    <el-radio-group v-model="networkName" class="network-name">
                        <el-radio-button v-for="(item,index) in networkNameGroup" 
                            :key="index"
                            :label="item.value">{{item.label}}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!-- 当前网口信息 -->
                <el-form-item :label="$t('privateNetInstance.currentNetworkMessage') | withColon">
                    <el-table :data="tableData">
                        <!-- 实例ID -->
                        <el-table-column
                            prop="instanceId"
                            :label="$t('listPage.text.exampleID')"
                            width="250">
                        </el-table-column>
                        <!-- 实例名称 -->
                        <el-table-column
                            prop="instanceName"
                            :label="$t('listPage.text.exampleName')"
                            min-width="120">
                        </el-table-column>
                        <!-- 可用区 -->
                        <el-table-column
                            key="azs"
                            :label="$t('list.region')"
                            width="120"
                            v-if="azs.length !== 0">{{transformAz(rowInfo.az)}}
                        </el-table-column>
                        <el-table-column
                            key="az"
                            :label="$t('list.region')"
                            width="120"
                            v-else>{{az}}
                        </el-table-column>
                        <!-- 主网口eth0-私有网络 -->
                        <el-table-column
                            v-if="networkName==='eth0'"
                            prop="privateNetwork"
                            key="privateNetwork"
                            :label="$t('subnet.text.privateNetwork')"
                            width="120">
                        </el-table-column>
                        <!-- 主网口eth0-子网 -->
                        <el-table-column
                            v-if="networkName==='eth0'"
                            prop="subnet"
                            key="subnet"
                            :label="$t('subnet.text.subnet')"
                            width="120">
                        </el-table-column>
                        <!-- 主网口eth0-内网IP -->
                        <el-table-column
                            v-if="networkName==='eth0'"
                            key="intranetIp"
                            :label="$t('detail.text.intranetIp')"
                            width="150">
                            <p v-if="rowInfo.privateIp" >{{rowInfo.privateIp + $t('privateNetInstance.private') }}</p>
                            <p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
                            <p v-if="rowInfo.ipv6Address" >{{ rowInfo.ipv6Address + $t('privateNetInstance.ipv6Address') }}</p>
                            <p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
                        </el-table-column>
                        <!-- 辅网口eth1-私有网络 -->
                        <el-table-column
                            v-if="networkName==='eth1'"
                            prop="extensionPrivateNetwork"
                            key="extensionPrivateNetwork"
                            :label="$t('subnet.text.privateNetwork')"
                            width="120">
                        </el-table-column>
                        <!-- 辅网口eth1-子网 -->
                        <el-table-column
                            v-if="networkName==='eth1'"
                            prop="extensionSubnet"
                            key="extensionSubnet"
                            :label="$t('subnet.text.subnet')"
                            width="120">
                        </el-table-column>
                        <!-- 辅网口eth1-内网IP -->
                        <el-table-column
                            v-if="networkName==='eth1'"
                            prop="extensionIntranetIp"
                            :label="$t('detail.text.intranetIp')"
                            width="150">
                            <p v-if="rowInfo.extensionPrivateIp" >{{rowInfo.extensionPrivateIp + $t('privateNetInstance.private') }}</p>
                            <p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
                            <p v-if="rowInfo.extensionIpv6Address" >{{ rowInfo.extensionIpv6Address + $t('privateNetInstance.ipv6Address') }}</p>
                            <p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item :label="$t('privateNetInstance.targetNetworkMessage') | withColon" >        
                </el-form-item>
                <div>
                    <el-form
                    ref="networkInfo"
                    :rules="networkInfoRules"
                    :model="netInfo"
                    class="net-form"
                    label-width="130px">
                        <!-- 私有网络 -->
                        <el-form-item :label="$t('privateNetInstance.targetPrivateNet')| withColon"
                            class="net-select" prop="selectVpcId">
                            <el-select v-model="netInfo.selectVpcId" class="select-vpc"
                                @change="(id)=>vpcChange(id,'netInfo')"
                                @visible-change="(isVisible)=>getRealTimeVpc(isVisible,'netInfo')"
                                :placeholder="$t('privateNetInstance.chooseTargetVPC')"
								:disabled="vpcNotChange">
                                <el-option v-for="(vpc, index) in vpcShowList"
                                    :key="index"
                                    :label="vpc.showName"
                                    :value="vpc.vpcId">
                                </el-option>
                            </el-select>
                            <span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcCidr">{{$t('privateNetInstance.privateNetCidr',[netInfo.selectVpcCidr])}}</span>
                            <span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[netInfo.selectVpcIpv6Cidr])}}</span>
                        </el-form-item>
                        <!-- 子网 -->
                        <el-form-item :label="$t('privateNetInstance.targetSubnet') | withColon"
                            class="net-select"
                            prop="selectSubnetId">
                            <el-select v-model="netInfo.selectSubnetId"
                                class="select-vpc"
                                :disabled="netInfo.subnetCount === 0||subnetNotChange"
                                @change="(subnetId)=>subnetChange(subnetId,'netInfo')"
                                @visible-change="(isVisible)=>getRealTimeSubnet(isVisible,'netInfo')"
                                :placeholder="netInfo.subnetCount === 0 ? $t('privateNetInstance.notSubnet') : $t('privateNetInstance.chooseTargetSubnet')">
                                <el-option v-for="(subnet, index) in subnetShowList"
                                    :key="index"
                                    :label="subnet.showName"
                                    :value="subnet.subnetId">
                                </el-option>
                            </el-select>
                            <span slot="hint" v-if="netInfo.selectSubnetId && netInfo.selectSubnetCidr">{{$t('privateNetInstance.privateNetCidr',[netInfo.selectSubnetCidr])}}</span>
                            <span slot="hint" v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[netInfo.selectSubnetIpv6Cidr])}}</span>
                        </el-form-item>
                        <!-- 内网IP -->
                        <el-form-item :label="$t('privateNetInstance.targetIntranetIp') | withColon">
                            <div class="ip-input">
                                <el-form-item>
                                    <el-select v-model="netInfo.isAuto" @change="clearInputIp('netInfo')">
                                        <el-option v-for="(operate, index) in netInfo.ipOperations"
                                            :key="index"
                                            :value="operate.value"
                                            :label="operate.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="internetIp">
                                    <el-input 
                                        :disabled="netInfo.isAuto === 1" 
                                        class="inner-ip"
                                        @keyup.native="trimValue('internetIp')"
                                        v-model="netInfo.internetIp"
                                        :placeholder="netInfo.isAuto? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpTip')">
                                    </el-input>
                                    <p slot="hint" v-if="netInfo.isAuto">
                                        {{ $t('privateNetInstance.intranetIpTip', [netInfo.selectSubnetCidr]) }}
                                    </p>
                                    <p slot="hint" v-else>
                                        {{ $t('privateNetInstance.internetIpTipTwo1',[netInfo.selectSubnetCidr]) }}
                                    </p>
                                </el-form-item>
                            </div>
                            <section>
                                <p v-if="(!netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr)||!netInfo.selectVpcId">{{$t('create.text.openIpv6WithoutVpcTip1')}}</p>
                                <p v-else-if="(netInfo.selectVpcId && !netInfo.selectSubnetId) || (netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr)">{{$t('create.text.openIpv6WithoutSubnetTip1')}}</p>

                            </section>
                        </el-form-item>
                    </el-form>
                </div>
            </el-form>
			<div slot="footer">
				<el-button @click="cancelBind">
					{{ $t('privateNetInstance.cancel') }}
				</el-button>
				<el-button @click="sureBind"
					key="button"
					:disabled="netInfo.selectVpcId === ''||netInfo.selectSubnetId === ''||buttonOnes||(netInfo.isAuto !== 1 && (netInfo.internetIp === ''||internetIpVaild))"
					type="primary"
                    :loading="isRequestLoading">
					{{ $t('privateNetInstance.bindSure') }}
				</el-button>
			</div> 
            <el-dialog
                width="30%"
                :title="$t('privateNetInstance.tip')"
                :visible.sync="innerVisible"
                append-to-body
            >
                <div>{{ $t('privateNetInstance.autoAllocationTip') }}</div>
                <div slot="footer">
                    <el-button @click="innerVisible = false">
                        {{ $t('privateNetInstance.cancel') }}
                    </el-button>
                    <el-button 
                        @click="sureBind"
                        key="button"
                        :disabled="!(netInfo.selectVpcId) || !(netInfo.selectSubnetId) || buttonOnes || (netInfo.isAuto !== 1 && (!netInfo.internetIp || internetIpVaild))"
                        type="primary"
                        :loading="isRequestLoading"
                    >
                        {{ $t('privateNetInstance.bindSure') }}
                    </el-button>
                </div> 
            </el-dialog>
		</el-dialog>
  </div>
</template>

<script>
import instanceDetailRequestMixins from '@/mixins/instanceDetailRequest';
export default {
    name: 'ReNetwork',
    mixins: [instanceDetailRequestMixins],
    props: {
            visible: {
                type: Boolean,
                default: false
            },
            rowInfo: {
                type: Object,
                default: () => {}
            },
			region: {
				type: String,
				default: ''
			},
            azs: {
                type: Array,
                default: []
            },
            az: {
                type: String,
                default: ''
            },
			vpcNotChange: {
				type: Boolean,
                default: false
			},
			subnetNotChange: {
				type: Boolean,
                default: false
			},
			networkNameTag:{
				type: String,
                default: 'eth0'
			},
        },

    data() {
        const validateIpAddress = (rule, value, callback) => {
			const reg = /^(10|11|172|192)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
			if (!this.netInfo.isAuto) {
				if (value === '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (this.networkName ==='eth0' && this.netInfo.selectSubnetId=== this.rowInfo.subnetId && value === this.rowInfo.privateIp){
					callback(new Error(this.$t('create.placeholder.ipAddressRepeat')));
				}
				if (this.networkName ==='eth1' && this.netInfo.selectSubnetId=== this.rowInfo.extensionSubnetId && value === this.rowInfo.extensionPrivateIp) {
					callback(new Error(this.$t('create.placeholder.ipAddressRepeat')));
				}
				if (!reg.test(value)) {
					callback(new Error(this.$t('create.placeholder.ipAddressNotPass')));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
            innerVisible: false,
			networkName:'eth0',
			realVpcId: '',
			buttonOnes: false,
			internetIpVaild: false,
			titles: [this.$t('privateNetInstance.operations.reVpcnetWork'),this.$t('privateNetInstance.operations.reSubnetwork'),this.$t('privateNetInstance.operations.reIntranetIp')],
			title: this.$t('privateNetInstance.operations.reVpcnetWork'),
			networkNameGroup: [
				{id:1,label:this.$t('eip.text.chiefInternetAccessName'),value:'eth0'}, // 主网口
				{id:2,label:this.$t('eip.text.subInternetAccessName'),value:'eth1'}, // 辅网口
			],
            tableData: [{
                instanceId:this.rowInfo.instanceId,
                instanceName:this.rowInfo.name,
                az:this.rowInfo.az,
                privateNetwork:this.rowInfo.vpcName,
                subnet:this.rowInfo.subnetName,
                intranetIp: [ this.rowInfo.privateIp,this.rowInfo.ipv6Address],
                extensionPrivateNetwork:this.rowInfo.extensionVpcName,
                extensionSubnet:this.rowInfo.extensionSubnetName,
                extensionIntranetIp: [ this.rowInfo.extensionPrivateIp,this.rowInfo.extensionIpv6Address],

            }],
            networkInfoRules: {
				selectVpcId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				selectSubnetId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				internetIp: [
					{
						validator: validateIpAddress,
						trigger: 'blur'
					}
				],
			},

            netInfo: {
				vpcCount: 0,
				subnetCount: 0,
				vpcList: [],
				vpcLists: [],
				subnetList: [],
				subnetLists: [],
				selectVpcId: '',
				selectVpcName: '',
				selectVpcCidr: '',
				selectVpcIpv6Cidr: '',
				selectSubnetId: '',
				selectSubnetName: '',
				selectSubnetCidr: '--',
				selectSubnetIpv6Cidr: '--',
				isAuto: 1,
				internetIp: '',
				ipOperations: [
					{
						value: 1,
						label: this.$t('privateNetInstance.autoIPv4')
					},
					{
						value: 0,
						label: this.$t('privateNetInstance.handwriteIPv4')
					}
				],
			},
		};
	},
    computed: {
        vpcShowList() {
			if(!this.vpcNotChange) {
				if (this.netInfo.vpcCount === 0) {
					this.netInfo.vpcList = [{
						vpcId: '',
						showName: this.$t('privateNetInstance.notVPC'),
					}];
				} else {
					this.netInfo.vpcList = this.netInfo.vpcList.map(vpc => ({
						vpcId: vpc.vpcId,
						showName: `${vpc.name}(${vpc.vpcId})`,
						name: vpc.name,
						cidr: vpc.cidr,
						ipv6Cidr: vpc.ipv6Cidr
					}));
				}
			}else {
				if (this.netInfo.vpcCount === 0) {
					this.netInfo.vpcList = [{
						vpcId: '',
						showName: this.$t('privateNetInstance.notVPC'),
					}];
				} else {
					this.netInfo.vpcList = this.netInfo.vpcLists.map(vpc => ({
						vpcId: vpc.vpcId,
						showName: `${vpc.name}(${vpc.vpcId})`,
						name: vpc.name,
						cidr: vpc.cidr,
						ipv6Cidr: vpc.ipv6Cidr
					}));
				}
				
			}
			const {vpcId, extensionVpcId, vpcCidr, extensionVpcCidr} = this.rowInfo || {}
			if(this.networkName==='eth0') {
				this.netInfo.vpcList = this.netInfo.vpcList?.length && this.netInfo.vpcList?.filter(item => item.vpcId !== vpcId && item.vpcId !== extensionVpcId  && item.cidr !== extensionVpcCidr)
			} else if(this.networkName==='eth1'){
				this.netInfo.vpcList = this.netInfo.vpcList?.length && this.netInfo.vpcList?.filter(item => item.vpcId !== vpcId && item.vpcId !== extensionVpcId && item.cidr !== vpcCidr)
			}
			return this.netInfo.vpcList || [];
			
		},
        subnetShowList() {
			if(!this.subnetNotChange) {
				if (this.netInfo.subnetList.length) {
					this.netInfo.subnetList = this.netInfo.subnetList.map(subnet => ({
						subnetId: subnet.subnetId,
						name: subnet.name,
						showName: `${subnet.name}(${subnet.subnetId})`,
						cidr: subnet.cidr,
						ipv6Cidr: subnet.ipv6Cidr,
						primaryCidr: subnet.cidr,
						region: subnet.region
					}));
				}
			}else {
				if (this.netInfo.subnetLists.length) {
					this.netInfo.subnetList = this.netInfo.subnetLists.map(subnet => ({
						subnetId: subnet.subnetId,
						name: subnet.name,
						showName: `${subnet.name}(${subnet.subnetId})`,
						cidr: subnet.cidr,
						ipv6Cidr: subnet.ipv6Cidr,
						primaryCidr: subnet.cidr,
						region: subnet.region
					}));
				}
			}
            this.netInfo.subnetList = this.netInfo.subnetList?.length && this.netInfo.subnetList?.filter(item=>item.subnetId !=this.rowInfo.extensionSubnetId && item.subnetId !=this.rowInfo.subnetId)
			// if(this.networkName==='eth0') {
			// 	this.netInfo.subnetList = this.netInfo.subnetList.filter(item=>item.subnetId !=this.rowInfo.extensionSubnetId)
			// } else if(this.networkName==='eth1'){
			// 	this.netInfo.subnetList = this.netInfo.subnetList.filter(item=>item.subnetId !=this.rowInfo.subnetId)
			// }
			return this.netInfo.subnetList || [];
			
		},
    },
    watch: {
        networkName() {
            this.getVpcCount('netInfo');
			if(this.vpcNotChange && !this.subnetNotChange) {
				this.existingVpcFixed();
			} else if (this.vpcNotChange && this.subnetNotChange) {
				this.getSubnetByVpc();
				this.existingVpcFixed();
				this.existingSubnetFixed();
			}else if(!this.vpcNotChange && !this.subnetNotChange) {
				this.netInfo = {
					vpcCount: 0,
					subnetCount: 0,
					vpcList: [],
					vpcLists: [],
					subnetList: [],
					subnetLists:[],
					selectVpcId: '',
					selectVpcName: '',
					selectVpcCidr: '',
					selectVpcIpv6Cidr: '',
					selectSubnetId: '',
					selectSubnetName: '',
					selectSubnetCidr: '--',
					selectSubnetIpv6Cidr: '--',
					isAuto: 1,
					internetIp: '',
					ipOperations: [
						{
							value: 1,
							label: this.$t('privateNetInstance.autoIPv4')
						},
						{
							value: 0,
							label: this.$t('privateNetInstance.handwriteIPv4')
						}
					],
				};
			}
            
		
        },
		"netInfo.internetIp"() {
			let formValid = true;
			this.$refs.networkInfo.validate((valid) => {
				formValid = valid;
			});
			if (!formValid&&this.netInfo.isAuto !== 1) {
				this.internetIpVaild = true
			}else{
				this.internetIpVaild = false
			}
		}
    },
    created() {
        this.getVpcCount('netInfo');
		if(this.vpcNotChange) {
			this.title=this.titles[1]
		}
		if(this.subnetNotChange) {
			this.title=this.titles[2]
		}
    },
	mounted() {
		this.networkName = this.networkNameTag;
		if(this.vpcNotChange) {
			this.getSubnetByVpc();
		}
	},
	beforeUpdate() {
		this.existingVpcFixed();
		this.existingSubnetFixed();
	},
    methods: {
        handleClose() {
                this.isRequestLoading = false;
                this.innerVisible = false;
                this.handleEmit();
                this.$emit('refresh');
                this.$emit('update:visible', false);
            },
        cancelBind() {
            this.handleClose();
        },
        sureBind() {
            // 更换 自动分配IPv4 vpcNotChange = true subnetNotChange=true,二次弹窗提示
            if (this.vpcNotChange && this.subnetNotChange && !this.innerVisible && this.netInfo.isAuto === 1) {
                this.innerVisible = true;
                return;
            }
			this.buttonOnes = true
            this.isRequestLoading = true;
			// if(!(this.netInfo.selectVpcId=== (this.rowInfo.vpcId||this.rowInfo.extensionVpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.subnetId||this.rowInfo.extensionSubnetId))) {
			// 	//this.changeVPC()
			// 	console.log('1')
			// }else if((this.netInfo.selectVpcId=== (this.rowInfo.vpcId||this.rowInfo.extensionVpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.subnetId||this.rowInfo.extensionSubnetId))) {
			// 	//this.changeSubnet()
			// 	console.log('2')
			// }else if((this.netInfo.selectVpcId=== (this.rowInfo.vpcId||this.rowInfo.extensionVpcId)) && (this.netInfo.selectSubnetId=== (this.rowInfo.subnetId||this.rowInfo.extensionSubnetId))) {
			// 	//this.changePrivateIp()
			// 	console.log('3')
			// }

			if(this.networkName ==='eth0') {
				if(!(this.netInfo.selectVpcId=== (this.rowInfo.vpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.subnetId))) {
					this.changeVPC()
				}else if((this.netInfo.selectVpcId=== (this.rowInfo.vpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.subnetId))) {
					this.changeSubnet()
				}else if((this.netInfo.selectVpcId=== (this.rowInfo.vpcId)) && (this.netInfo.selectSubnetId=== (this.rowInfo.subnetId))) {
					this.changePrivateIp()
				}
			}else if (this.networkName ==='eth1') {
				if(!(this.netInfo.selectVpcId=== (this.rowInfo.extensionVpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.extensionSubnetId))) {
					this.changeVPC()
				}else if((this.netInfo.selectVpcId=== (this.rowInfo.extensionVpcId)) && !(this.netInfo.selectSubnetId=== (this.rowInfo.extensionSubnetId))) {
					this.changeSubnet()
				}else if((this.netInfo.selectVpcId=== (this.rowInfo.extensionVpcId)) && (this.netInfo.selectSubnetId=== (this.rowInfo.extensionSubnetId))) {
					this.changePrivateIp()
				}
			}
        },
		changeVPC() {
			const params = {
                region: this.region,
                instanceId: this.rowInfo.instanceId,
				interfaceName : this.networkName,
				targetVpcIden: this.netInfo.selectVpcId,
                targetSubnetIden: this.netInfo.selectSubnetId,	
            };
			if (!this.netInfo.isAuto) {
				params.targetRip = this.netInfo.internetIp;
			}
            Ajax.post('/api/cps/modifyInstanceVPC', params)
            .then((res) => {
               this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			   this.handleClose();
            })
            .catch(async (err) => {
                const { response } = err.data;
                this.buttonOnes = false;
                this.innerVisible = false;
                try {
                    const json = await response.json();
                    // 拦截IPv4校验重复的枚举转译
                    let messageTip = '';
                    if (json.errmsg === 'RIP_DUPLICATE') {
                        messageTip = 'IPv4 地址已占用，请重新输入';
                    }
                    this.isRequestLoading = false;
                    this.$message.error(messageTip || json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
				this.$emit('refresh');
                // this.handleClose();                
            });
		},
		changeSubnet() {
			const params = {
                region: this.region,
                instanceId: this.rowInfo.instanceId,
				interfaceName : this.networkName,
                targetSubnetIden: this.netInfo.selectSubnetId,	
            };
			if (!this.netInfo.isAuto) {
				params.targetRip = this.netInfo.internetIp;
			}
            Ajax.post('/api/cps/modifyInstanceSubNet', params)
            .then((res) => {
               this.$message.success(this.$t('privateNetInstance.operateSuccess'));
               this.handleClose();
			   
            })
            .catch(async (err) => {
                const { response } = err.data;
                this.buttonOnes = false;
                this.innerVisible = false;
                try {
                    const json = await response.json();
                    // 拦截IPv4校验重复的枚举转译
                    let messageTip = '';
                    if (json.errmsg === 'RIP_DUPLICATE') {
                        messageTip = 'IPv4 地址已占用，请重新输入';
                    }
                    this.isRequestLoading = false;
                    this.$message.error(messageTip || json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
				this.$emit('refresh');
                // this.handleClose();               
            });
		},
		changePrivateIp() {
			const params = {
                region: this.region,
                instanceId: this.rowInfo.instanceId,
				interfaceName : this.networkName,	
            };
			if (!this.netInfo.isAuto) {
				params.targetRip = this.netInfo.internetIp;
			}
            Ajax.post('/api/cps/modifyInstanceRip', params)
            .then((res) => {
               this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			   this.handleClose(); 
            })
            .catch(async (err) => {
                const { response } = err.data;
                this.buttonOnes = false;
                this.innerVisible = false;
                try {
                    const json = await response.json();
                    // 拦截IPv4校验重复的枚举转译
                    let messageTip = '';
                    if (json.errmsg === 'RIP_DUPLICATE') {
                        messageTip = 'IPv4 地址已占用，请重新输入';
                    }
                    this.isRequestLoading = false;
                    this.$message.error(messageTip || json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
				this.$emit('refresh');
                // this.handleClose();             
            });
		},
        transformAz(vaule) {
	      	let realAz;
	      	this.azs.forEach((az) => {
		        if (az.value === vaule) {
		        	realAz = az.text;
		        }
	      	});
	      	return realAz;
	    },
        // 获取选中当前vpc
		vpcChange(id,tag) {
			if (tag === 'netInfo') {
				this.selectedSubnetDetail = {};
				this.$refs.networkInfo.clearValidate(['selectSubnetId']);
			}
			this[tag].selectSubnetId = '';
			this[tag].selectSubnetName = '';
			this[tag].selectSubnetCidr = '--';
			this[tag].selectSubnetIpv6Cidr = '--';
            this[tag].subnetList = [];
            this[tag].subnetLists = []
            this[tag].subnetCount = 0;
			this.resetIpv4(tag);
			if (id) {
				this.getSubnetByVpc(id);
				this.getSelectVpcName(id,tag);
				this.getSelectVpcCidr(id,tag);
			}
		},
        resetIpv4(tag) {
			this[tag].isAuto = 1;
			this[tag].internetIp = '';
		},
        // 获取当前vpc下子网
		getSubnetByVpc(id) {
			if(this.networkName==='eth0') {
				this.realVpcId = this.vpcNotChange ? this.rowInfo.vpcId : id
			} else if(this.networkName==='eth1') {
				this.realVpcId = this.vpcNotChange ? this.rowInfo.extensionVpcId : id
			};
			const params = {
				region: this.region,	
				vpcId: this.realVpcId,
				pageSize: 100
			};
			Ajax.get('/api/cps/listSubnets', params)
			.then((res) => {
                const {subnets} = res.data || {};
                if (subnets && subnets?.length) {
                    this.netInfo.subnetList = subnets
                    this.netInfo.subnetLists = subnets
                    this.netInfo.subnetCount = subnets.length;
                }
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
		},
        // 获取选中vpc名称
		getSelectVpcName(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcName = vpc.name;
				}
			});
		},
        // 获取选中vpc cidr及ipv6 cidr
		getSelectVpcCidr(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcCidr = vpc.cidr;
					this[tag].selectVpcIpv6Cidr = vpc.ipv6Cidr;
				}
			});
		},
        /*
		*  当前页面可以跳转其它页面创建vpc
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeVpc(isVisible,tag) {
			if (isVisible) {
				this.getVpcCount(tag);
			}
		},
        // 获取当前区域下vpc
		getVpcCount(tag) {
            const {vpcCidr, extensionVpcCidr} = this.rowInfo || {};
			const params = {
				pageNumber: 1,
				pageSize: 100,
				region: this.region,
			};
            if (this.networkName==='eth0') {
                params.cidrToFilter = extensionVpcCidr;
            } else if (this.networkName==='eth1') {
                params.cidrToFilter = vpcCidr;
            }
			Ajax.get('/api/cps/listVpcs', params)
			.then((res) => {
                const {vpcs} = res.data || {};
				if (vpcs && vpcs?.length) {
					this.netInfo.vpcLists = vpcs
                    this.netInfo.vpcList = vpcs;
                    this.netInfo.vpcCount  = vpcs.length;
				}
			})
			.catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });
		},
		//下拉框默认带出当前网口的VPC信息，置灰不可修改
		existingVpcFixed() {
			if(this.vpcNotChange) {
				if(this.networkName==='eth0') {
					this.netInfo.selectVpcId = this.rowInfo.vpcId
				}else if(this.networkName==='eth1') {
					this.netInfo.selectVpcId = this.rowInfo.extensionVpcId
				};
				this.netInfo.vpcLists.forEach((vpc) => {
					if (vpc.vpcId === this.netInfo.selectVpcId) {
						this.netInfo.selectVpcCidr = vpc.cidr;
						this.netInfo.selectVpcIpv6Cidr = vpc.ipv6Cidr;
					}
				});
			}
		},
		//下拉框默认带出当前网口的子网信息，置灰不可修改
		existingSubnetFixed() {
			if(this.subnetNotChange) {
				if(this.networkName==='eth0') {
					this.netInfo.selectSubnetId = this.rowInfo.subnetId
				}else if(this.networkName==='eth1') {
					this.netInfo.selectSubnetId = this.rowInfo.extensionSubnetId
				};
				this.netInfo.subnetLists.forEach((subnet) => {
					if (subnet.subnetId === this.netInfo.selectSubnetId) {
						this.selectedSubnetDetail = subnet;
						this.netInfo.selectSubnetName = subnet.name;
						this.netInfo.selectSubnetCidr = subnet.cidr;
						this.netInfo.selectSubnetIpv6Cidr = subnet.ipv6Cidr;	
					}
				})
				
			}
		},
        // 获取选取子网名称
		subnetChange(subnetId,tag) {
			this[tag].subnetList.forEach((subnet) => {
				if (subnet.subnetId === subnetId) {
					if (tag === 'netInfo') {
						this.selectedSubnetDetail = subnet;
					}
					this[tag].selectSubnetName = subnet.name;
					this[tag].selectSubnetCidr = subnet.cidr;
					this[tag].selectSubnetIpv6Cidr = subnet.ipv6Cidr;
					this.resetIpv4(tag)
				}
			})
		},
        /*
		*  当前页面可以跳转其它页面创建subnet
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeSubnet(isVisible,tag) {
			if (!isVisible) {
				return
			}
			let vpcId = this[tag].selectVpcId
			this.getSubnetByVpc(vpcId);
		},
        trimValue(type) {
			if (type === 'internetIp') {
				this.netInfo.internetIp  = this.netInfo.internetIp.replace(/^\s+|\s+$/g,'');
			}
		},
        clearInputIp(tag) {
			this[tag].internetIp = '';
		},  
    }
}
</script>

<style lang="scss">
.renetwork-container {
    .el-form .el-form-item__content > .el-select {
		width: 320px;
	}
	.el-form .el-form-item__content > .el-input {
		width: 320px;
	}
	.el-radio-button__inner {
		padding:0 10px 0 10px;
	}
	.network-name {
		.el-radio-button__inner {
			padding: 10px;
		}
	}
    .ip-input {
			display: flex;
            flex-wrap: wrap;
			.inner-ip {
				// margin-left: 20px;
				width: 300px;
			}
			.ipv6 {
				margin-left: 10px;
				width: 100px;
			}

            .el-form-item {
                margin-right: 20px;
            }

			.el-form-item__error {
				padding-top: 2px;
				margin-left: 20px;
			}

			.el-form-item-help {
				margin-left: 20px;
			}
		}
    .el-form-item.is-hint {
        margin-bottom: 0px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/privateNetInstance/operates/ReNetwork.vue